import { getInventory } from "./inventoryAction";
import { getProducts } from "./productAction";
import { getShops } from "./shopAction";
import { getSale, getSales } from "./saleAction";
import { getArrivages, getPurchases, getDemandes } from "./purchaseAction";
import { getClients } from "./clientAction";
import { errorPage, loadingState, fetchState } from "./inventoryStateAction";
import { formatData, formatDataStats, formatDataClientStats, formatDataProds, sortByDate, sortByDateReverse } from './utils'
import { getResas } from "./resaAction";
import { getInstalls } from "./installAction";
/*stock : {
    idProd:
    idLocation:
    quantity:
}*/

export function fetchAll(){
    return async function action(dispatch){
        dispatch({
            type: "FETCH_INIT_DATA_START",
            payload: ""
        })
        try{

            const res = await fetch('/stocks/getAll',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                
                credentials: 'same-origin',
            });
            let infos = await res.json();
            console.log({infos});
            if(infos.error){ 
                console.log("[ERROR] get store account info ",infos.error);
                dispatch({
                    type: "FETCH_INIT_DATA_ERROR",
                    payload: infos.error
                })
            } else {
    
                const products = formatDataProds(infos.product_list ? infos.product_list.reverse() : infos.product_list)
                const shops = formatData(infos.shop_list ? infos.shop_list.reverse() : infos.shop_list)
                const stocks = formatData(infos.stock_list ? infos.stock_list.reverse() : infos.stock_list)
                const clients = formatData(infos.client_list ? infos.client_list.reverse() : infos.client_list)
                const commercials = formatData(infos.commercial_sale_list)
                const purchases = formatData(infos.purchase_list)
                const sales = formatData(infos.sale_list)

                // if !errors ...
                dispatch(getProducts(products))
                dispatch(getShops(shops))
                dispatch(getSales(sales))
                dispatch(getInventory(stocks))
                dispatch(getPurchases(purchases))
                dispatch({
                    type: "GET_CLIENTS", payload:clients
                })
                dispatch({
                    type: "GET_COMMERCIAL_REAS", payload:commercials
                })
                
                dispatch({ type: "FETCH_INIT_DATA_FULFILLED", payload:"" })
            }
        } catch(error){
            console.log("[ERROR] get store account info ALL", error);
                dispatch({
                    type: "FETCH_INIT_DATA_ERROR",
                    payload: error
                    
                })
        }

    }
}

export function fetchAllPart1(){
    return async function action(dispatch){
        dispatch({
            type: "FETCH_INIT_DATA_START",
            payload: ""
        })
        try{

            const res = await fetch('/stocks/getAll/part1',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                
                credentials: 'same-origin',
            });
            let infos = await res.json();
            console.log({infos});
            if(infos.error){ 
                console.log("[ERROR] get store account info ",infos.error);
                dispatch({
                    type: "FETCH_INIT_DATA_ERROR",
                    payload: infos.error
                })
            } else {
    
                const products = formatDataProds(infos.product_list ? infos.product_list.reverse() : infos.product_list)
                const shops = formatData(infos.shop_list ? infos.shop_list.reverse() : infos.shop_list)
                const stocks = formatData(infos.stock_list ? infos.stock_list.reverse() : infos.stock_list)
                const clients = formatData(infos.client_list ? infos.client_list.reverse() : infos.client_list)
                const clientStats = formatDataClientStats(infos.client_city_stats)

                console.log({clientStats});
                // if !errors ...
                dispatch(getProducts(products))
                dispatch(getShops(shops))
                dispatch(getInventory(stocks))
                dispatch({ type: "GET_CLIENTS", payload: clients })
                dispatch({ type: "GET_STATS_CLIENTS_CITY", payload: clientStats })
                
                dispatch({ type: "FETCH_INIT_DATA_FULFILLED", payload:"" })
            }
        } catch(error){
            console.log("[ERROR] get store account info Part1", error);
                dispatch({
                    type: "FETCH_INIT_DATA_ERROR",
                    payload: error
                    
                })
        }

    }
}
export function fetchAllPart2(){
    return async function action(dispatch){
        dispatch({
            type: "FETCH_INIT_DATA2_START",
            payload: ""
        })
        try{

            const res = await fetch('/stocks/getAll/part2',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                
                credentials: 'same-origin',
            });
            let infos = await res.json();
            console.log({infos});
            if(infos.error){ 
                console.log("[ERROR] get store account info ",infos.error);
                dispatch({
                    type: "FETCH_INIT_DATA2_ERROR",
                    payload: infos.error
                })
            } else {

                const purchases = formatData(infos.purchase_list)
                const sales = formatData(infos.sale_list)
                // const resas = formatData(infos.resa_list)
                const installs = formatData(infos.install_list)
                const top_products = formatDataStats(infos.top_products)

                dispatch(getSales(sales))
                // dispatch(getResas(resas))
                dispatch(getInstalls(installs))
                dispatch(getPurchases(purchases))                
                dispatch({ type: "GET_TOP_PRODUCTS", payload: top_products })
                
                dispatch({ type: "FETCH_INIT_DATA2_FULFILLED", payload:"" })
            }
        } catch(error){
            console.log("[ERROR] get store account info Part2", error);
                dispatch({
                    type: "FETCH_INIT_DATA2_ERROR",
                    payload: error
                    
                })
        }

    }
}
export function fetchAllPart3(){
    return async function action(dispatch){
        dispatch({
            type: "FETCH_INIT_DATA3_START",
            payload: ""
        })
        try{

            const res = await fetch('/stocks/getAll/part3',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                
                credentials: 'same-origin',
            });
            let infos = await res.json();
            console.log({infos});
            if(infos.error){ 
                console.log("[ERROR] get store account info ",infos.error);
                dispatch({
                    type: "FETCH_INIT_DATA3_ERROR",
                    payload: infos.error
                })
            } else {

                const commercials = infos.commercial_sale_list ? formatData(sortByDateReverse(infos.commercial_sale_list)) : {}
                const rectifs = infos.commercial_rectif_list ? formatData(sortByDateReverse(infos.commercial_rectif_list)) : {}
                // const orders = formatData(sortByDateReverse(infos.order_sale_list))
                const arrivages = formatData(infos.arrivage_list)
                const demands = formatData(infos.demand_list)

                dispatch({
                    type: "GET_COMMERCIAL_REAS", payload:commercials
                })
                dispatch({
                    type: "GET_COMMERCIAL_RETURNS", payload:rectifs
                })
                dispatch(getArrivages(arrivages))
                dispatch(getDemandes(demands))
                // dispatch({
                //     type: "GET_ORDERS", payload:orders
                // })
                
                dispatch({ type: "FETCH_INIT_DATA3_FULFILLED", payload:"" })
            }
        } catch(error){
            console.log("[ERROR] get store commercials op info ", error);
                dispatch({
                    type: "FETCH_INIT_DATA3_ERROR",
                    payload: error
                    
                })
        }

    }
}

export function getStoreClients(){
    return async function action(dispatch){
        dispatch({
            type: "FETCH_STORE_CLIENT_START",
            payload: ""
            
        })
        try{
            const res = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"clients"
                }),
                credentials: 'same-origin',
            });
            let infos = await res.json();
            console.log({infos});
            if(infos.error){ 
                console.log("[ERROR] get store store client info ",infos.error);
                dispatch({
                    type: "FETCH_STORE_CLIENT_ERROR",
                    payload: infos.error
                    
                })

            } else {
                const clients = formatData(infos ? infos.reverse() : infos)
                
                dispatch({
                    type: "GET_CLIENTS", payload:clients
                })
                
                dispatch({ type: "FETCH_STORE_CLIENT_FULFILLED", payload:"" })
            }
        } catch(error){
            console.log("[ERROR] get store store client info ", error);
                dispatch({
                    type: "FETCH_STORE_CLIENT_ERROR",
                    payload: error
                    
                })
        }

    }
}


// DO NOT WORK !!!!!!!
export function fetchAgentsStock(idCommercial){
    return async function action(dispatch){
        dispatch({
            type: "FETCH_STOCK_AGENT_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/commercial/agent/stockList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({commercialID: idCommercial}),
                credentials: 'same-origin',
            }); 
            const list = await response.json()
            if(list.error){ // no errors, return new Object
                console.log("error list fetched", list.error)
                dispatch({type: "FETCH_STOCK_AGENT_ERROR",payload: list.error})
            } else {
                const stocks = list
                dispatch({ type: "FETCH_STOCK_AGENT_FULFILLED", payload:stocks })
            }    
        } catch(error){
            console.log("[ERROR] get store store client info ", error);
                dispatch({
                    type: "FETCH_STOCK_AGENT_ERROR",
                    payload: error
                })
        }
    }
}